import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_PATIENTINVOICEDETAILS_INIT_ACTION,
  FETCH_PATIENTINVOICEDETAILS_SUCCESS_ACTION,
  FETCH_PATIENTINVOICEDETAILS_FAIL_ACTION,
  FETCH_PATIENTINVOICESTATUSCHANGE_INIT_ACTION,
  FETCH_PATIENTINVOICESTATUSCHANGE_SUCCESS_ACTION,
  FETCH_PATIENTINVOICESTATUSCHANGE_FAIL_ACTION,
} from "./action";

import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function* fetchPatientInvoice(value) {
  const token = localStorage.getItem("token");

  let pageno = !value.value
    ? 1
    : value.value.page === undefined
    ? 1
    : value.value.page;
  let search = !value.value
    ? ""
    : value.value.search === ""
    ? ""
    : value.value.search;
  let status = !value.value
    ? ""
    : value.value.filter === ""
    ? ""
    : value.value.filter;

  try {
    const res = yield fetch(
      `${appConfig.ip}/invoice?invType=patient&&limit=10&page=${pageno}&search=${search}&status=${status}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_PATIENTINVOICEDETAILS_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_PATIENTINVOICEDETAILS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchPatientInvoiceStatusChange(data) {

  let datas;

  data.value.item.status === "paid"
    ? (datas = {
        status: "cancelled"
      })
    : (datas = {
        status: "paid"
      });

  const id = data.value.item.id;

  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(`${appConfig.ip}/invoice/changeStatus/` + id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(datas)
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield toast.success("Status changed successfully", {
        autoClose: 3000
      });
      yield put({
        type: FETCH_PATIENTINVOICESTATUSCHANGE_SUCCESS_ACTION,
        payload: resJSON
      });

      const refreshParams =
        data &&
        data.value &&
        data.value.refreshParams
          ? data.value.refreshParams
          : undefined;
      yield put({
        type: FETCH_PATIENTINVOICEDETAILS_INIT_ACTION,
        value: refreshParams
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_PATIENTINVOICESTATUSCHANGE_FAIL_ACTION, error: err });
    } else {
    }
  }
}

export function* PatientInvoiceActionWatcher() {
  yield takeEvery(FETCH_PATIENTINVOICEDETAILS_INIT_ACTION, fetchPatientInvoice);
  yield takeEvery(FETCH_PATIENTINVOICESTATUSCHANGE_INIT_ACTION, fetchPatientInvoiceStatusChange);
}
